import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

const fields = [
  ["First name", "first_name"],
  ["Last name", "last_name"],
  ["Email", "email_address"],
  ["Phone", "phone"],
  ["Mobile", "mobile"],
  ["Organization", "organization"],
  ["Location", "your_location"],
  ["Language", "language"],
  ["Role", "role_id"],
  ["Status", "status"],
  ["Joined", "created_date_time"],
];

function ProfileDetailsRows({ user, roleName }) {
  return fields.map(([label, key]) => {
    let value = key === "role_id" ? roleName : user?.[key];
    if (key === "created_date_time" && value) {
      const date = new Date(value);
      value = Number.isNaN(date.getTime()) ? value : date.toLocaleDateString();
    }

    return (
      <SoftBox
        key={key}
        display="grid"
        alignItems="center"
        py={2}
        sx={{
          gridTemplateColumns: { xs: "1fr", sm: "minmax(140px, 32%) minmax(0, 1fr)" },
          gap: { xs: 0.75, sm: 2 },
          borderBottom: "1px solid var(--portal-surface-border)",
          "&:last-child": { borderBottom: "none", pb: 0 },
        }}
      >
        <SoftTypography variant="button" fontWeight="medium" sx={{ opacity: 0.7 }}>
          {label}
        </SoftTypography>
        <SoftTypography variant="button" fontWeight="regular" color="text" sx={{ overflowWrap: "anywhere" }}>
          {value == null || String(value).trim() === "" ? "—" : value}
        </SoftTypography>
      </SoftBox>
    );
  });
}

export default ProfileDetailsRows;
